import { convertArrayToObject, replaceArrayElement } from '@/helpers/utils'
import Vue from 'vue'
import { defaultObjectMapData } from './defaults'
import { layerSettingsFactories } from './layerSettingsFactory'

const requests = {
  zonegroup: null,
  emitter: null,
  zones: null,
  building: null,
  infrastructure: null,
  route: null,
  source: null,
  borders: null,
  flow: null,
  info: null,
  containerplatform: null,
  transportbase: null,
  rule: null,
  all: null,
  cache: null,
  zoneGroupColors: null,
  infrastructureColors: null,
  streaminfoRoute: null
}

const infrastructureStatuses = {
  active: 'Действующий',
  planned: 'Планируемый к вводу в эксплуатацию',
  awaiting: 'Ожидающий расчет',
  closed: 'Выведенный из эксплуатации',
  unused: 'Неиспользуемый'
}

const ENTITIES_WITH_ADDITIONAL_DATA = ['zone', 'adm_territory', 'dedicated_territory']

/**Мэппинг названий слоев из ответа layerload, чтобы получить актуальные названия (id) слоев */
const LAYER_ID_BY_LAYERLOAD_ENTITY = {
  emitters: 'emitter',
  round: 'collectingloop',
  cruise: 'transfer',
  trip: 'removaltrip'
}

const LAYERLOAD_ENTITY_BY_DATASOURCE = {
  emitter: 'emitters',
  collectingloop: 'round',
  transfer: 'cruise',
  removaltrip: 'trip'
}

const SPECIAL_LAYERLOAD_ENTITIES = ['flow', 'source', 'infrastructure', 'zonegroup']

const NO_FILTER_ENTITIES = ['zonegroup']

const CONTAINER_PLATFORM_ROUTE_LAYER_ID = 'removal_trip_for_container_platform'
const CONTAINER_PLATFORM_ROUTE_STYLE_ID = 'removal_trip_for_cp_style'
const CONTAINER_PLATFORM_ROUTE_STYLE_SELECTED_ID = 'removal_trip_for_cp_style_selected'
const CONTAINER_PLATFORM_ROUTE_LAYER_SETTINGS = {
  id: CONTAINER_PLATFORM_ROUTE_LAYER_ID,
  parentId: null,
  groupLayer: false,
  name: 'Маршруты вывоза для КП на последний период',
  order: 10,
  visibility: false,
  zoneVisibility: false,
  open: false,
  scrollable: true,
  canToggleItemsVisibility: false,

  /**Поля которые надо запросить у серевера при запросе объектов. По умолчанию 'id,name'*/
  fields: 'id,color,route',

  /**При клике на линию чувствительность в пикселях */
  tolerance: 5,

  alwaysShowInPanel: true,
  layerLoadEntity: null,
  hideFromLeftPanel: true,

  labels: {
    collapseButton: 'Закрыть список петель сбора',
    expandButton: 'Открыть список петель сбора'
  },
  type: 'vectorTile',
  styleId: CONTAINER_PLATFORM_ROUTE_STYLE_ID,
  selectedStyleId: CONTAINER_PLATFORM_ROUTE_STYLE_SELECTED_ID,
  dataSource: 'removalTripMVT',
  url: 'api/mvt/removal_trip/?x={x}&y={y}&zoom={z}',
  detailInfoType: 'removaltrip',
  tooltipSettings: {
    minWidth: 280,
    offset: { x: 0, y: 0 },
    autoPan: false,
    closeButton: false,
    className: 'Popup--toBottom'
  },
  tooltipTemplate:
    '<div class="LeafletPopup-main LeafletRouterPopup"><div class="LeafletPopup-title">Маршрут вывоза</div><div><b>№ ${properties.id}</b></div></div>',
  multipleTooltipTemplate: `<div class="LeafletPopup-main LeafletRouterPopup">
      <div class="LeafletPopup-title">Маршруты вывоза: \${propertiesArray.length}шт.</div>
      </div>`
}

const CONTAINER_PLATFORM_ROUTE_STYLE = {
  type: 'VectorTile',
  options: {
    default: {
      type: 'PolylineDecorated',
      options: {
        weight: 2,
        color: '#ff6600',
        dashArray: '6, 6, 1, 6',
        decorator: {
          offset: 0,
          endOffset: 0,
          repeat: 500,
          type: 'CanvasMarker',
          options: {
            img: {
              icon: 'direction',
              size: ['literal', [19, 18]],
              rotate: 0,
              offset: { x: 0, y: 0 }
            }
          }
        }
      }
    }
  }
}
const CONTAINER_PLATFORM_ROUTE_STYLE_SELECTED = {
  default: {
    type: 'PolylineDecorated',
    options: {
      color: '#ff6600',
      weight: 10,
      lineCap: 'square',
      dashArray: ''
    }
  }
}

export default {
  setObjectSelected({ getters, dispatch, commit }, item) {
    commit('setObjectStaticInfo', [])
    commit('setObjectSelected', item)
    if (item && !item.ids) {
      return
    }
    dispatch('getObjectDetailsInfo', item)
    commit('setShowContainerRoute', false)

    /*if(getters.objectSelected && item && getters.objectSelected.type === item.type && getters.objectSelected.ids.join(',') === item.ids.join(',')) {
      return Promise.resolve()
    }*/
    if (item) {
      let url = ''
      const params = {
        workspace: getters.workspace,
        version: getters.version
      }
      if (!item.skipPeriodFilter) {
        params[getters.objectsPeriod.scaleType.id] = getters.objectsPeriod.borders[0]
      }
      switch (item.type) {
        case 'emitter':
          url = getters.endpoint.emitter
          params.ids = item.ids.join(',')
          break
        case 'building':
          url = getters.endpoint.building
          params.ids = item.ids.join(',')
          break
        case 'technologies':
          url = getters.endpoint.technologies
          params.ids = item.ids.join(',')
          break
        case 'transportbase':
          url = getters.endpoint.transportBase
          params.ids = item.ids.join(',')
          break
        case 'infrastructure':
          url = getters.endpoint.infrastructure
          params.ids = item.ids.join(',')
          break
        case 'info':
          url = getters.endpoint.excelLayers.layerObject
          delete params.period
          params.id = item.subtype
          params.obj_ids = item.ids.join(',')
          break
        case 'streaminfo':
          url = getters.endpoint.excelLayers.layerObject
          delete params.period
          params.id = item.subtype
          params.obj_ids = item.ids.join(',')
          break
        case 'adm_territory':
          url = getters.endpoint.admterritory
          break
        case 'dedicated_territory':
          url = getters.endpoint.separateterritory
          break
        case 'flow':
          url = getters.endpoint.flow
          break
        case 'source':
          url = getters.endpoint.source
          break
        case 'removaltrip':
          url = getters.endpoint.tripProperties
          break
        case 'collectingloop':
          url = getters.endpoint.loopProperties
          break
        case 'transfer':
          url = getters.endpoint.transferProperties
          break
        case 'containerplatform':
          url = getters.endpoint.containerplatform
          break
        case 'zone':
          url = getters.endpoint.zones
          break
      }

      if (item.ids.length === 1 && item.type !== 'info' && item.type !== 'streaminfo') {
        url += item.ids[0] + '/'
      } else if (item.type !== 'info' && item.type !== 'streaminfo') {
        params.ids = item.ids.join(',')
      }
      commit('setObjectLoadingData', 1)
      commit('setRawSelectedObjectInfo', { rawSelectedObjectInfo: null })

      let loadFieldsControlDictPromise = Promise.resolve()
      //Для публичных WS загрузим словарь скрытых полей, если он еще не был загружен
      if (!getters.fieldsControlDict && getters.isPublicWs) {
        loadFieldsControlDictPromise = dispatch('loadFieldsControlDict')
      }

      return loadFieldsControlDictPromise.then(() => {
        return Vue.http
          .get(url, {
            params
          })
          .then((r) => {
            const objects =
              item.type !== 'info' && item.type !== 'streaminfo'
                ? r.body.results
                  ? r.body.results
                  : r.body instanceof Array
                  ? r.body
                  : [r.body]
                : r.body.result

            if (objects.length === 0) {
              commit('setApiErrorInfo', 'Выбранные объекты не существует в заданном периоде')
              commit('setObjectSelected', null)
              commit('setRawSelectedObjectInfo', { rawSelectedObjectInfo: null })
              return
            }

            const formatProperties = (object, parentFields = []) => {
              const list = []
              if (object.treatment_type) {
                object.treatment_type = !(object.treatment_type instanceof Object) ? [getters.treatmentsMap[object.treatment_type]] : object.treatment_type
                object.treatment_type =
                  object.treatment_type.length > 0 ? object.treatment_type.map((v) => (v.id ? v : getters.treatmentsMap[v])).filter((v) => v) : null
              }
              if (object.treatment_input) {
                object.treatment_input = object.treatment_input.length > 0 ? object.treatment_input.map((v) => getters.treatmentsMap[v]).filter((v) => v) : null
                if (object.treatment_input && object.treatment_input.length === 0) {
                  object.treatment_input = null
                }
              }
              if (object.treatment_output) {
                object.treatment_output =
                  object.treatment_output.length > 0 ? object.treatment_output.map((v) => getters.treatmentsMap[v]).filter((v) => v) : null
                if (object.treatment_output && object.treatment_output.length === 0) {
                  object.treatment_output = null
                }
              }

              Object.keys(object).forEach((key) => {
                if (object[key] || object[key] === 0) {
                  let value = object[key]
                  let type = 'String'
                  if (['treatment_type', 'treatment_input', 'treatment_output'].indexOf(key) > -1) {
                    type = 'Treatments'
                  } else if (['point'].indexOf(key) > -1) {
                    type = 'Point'
                  } else if (['long_data'].indexOf(key) > -1) {
                    type = 'LongInfoArray'
                  } else if (['bounds', 'boundary'].indexOf(key) > -1) {
                    type = 'Bounds'
                  } else if (Array.isArray(value)) {
                    type = 'Array'
                    value = value.map((v) => {
                      return v instanceof Object || Array.isArray(v) ? formatProperties(v, [...parentFields, key]) : v
                    })
                  } else if (value instanceof Object) {
                    type = 'Object'
                    value = [formatProperties(value, [...parentFields, key])]
                  }

                  list.push({
                    title: key,
                    type,
                    value,
                    parentFields
                  })
                } else {
                  list.push({
                    title: key,
                    type: 'String',
                    value: '-',
                    parentFields
                  })
                }
              })
              const nameIndex = list.findIndex((v) => v.title === 'name')
              if (nameIndex > 0) {
                replaceArrayElement(list, nameIndex, 0)
              }

              return list
            }

            let objectsFormatted = []
            objects.forEach((object) => {
              if (object.point) {
                if (item.type === 'source') {
                  object.point = object.point && object.point.point ? object.point.point : object.point
                }
              }

              let hiddenFields = []
              if (getters.isPublicWs && getters.fieldsControlDict && getters.fieldsControlDict[item.type]) {
                const fieldsControlDictKey = item.type === 'adm_territory' ? 'admterritory' : item.type

                //Получение скрытых полей по типу сущности
                const entityFieldsControlDict = getters.fieldsControlDict[fieldsControlDictKey]
                //Получение полей, скрытых для всех сущностей
                const allHiddenFields = entityFieldsControlDict.all || []
                //Получение полей скрытых для текущей сущности
                const objectHiddenFields = entityFieldsControlDict.detail ? entityFieldsControlDict.detail[object.id] || [] : []

                hiddenFields = [...allHiddenFields, ...objectHiddenFields]
              }

              if (item.type === 'infrastructure') {
                if (!hiddenFields.includes('status')) {
                  object.status = object.status ? infrastructureStatuses[object.status] : null
                }
                if (!hiddenFields.includes('territory')) {
                  object.territory = object.territory ? object.territory.name || '-' : '-'
                }
                if (!hiddenFields.includes('technologies')) {
                  object.technologies = (object.technologies || []).map((v) => {
                    const value = {
                      ...v,
                      name: v.name || 'Технология ' + v.id
                    }
                    const cf = getters.convertfunctions.filter((f) => f.id === v.convert_function)[0]
                    const ec = getters.economicModels.filter((f) => f.id === v.economics)[0]
                    value.convert_function = cf ? cf.name : v.convert_function
                    value.economics = ec ? ec.name : v.economics
                    if (!value.is_placement) {
                      delete value.capacity_rest
                      delete value.capacity_full
                    }
                    return value
                  })
                }
              }

              if (item.type === 'technologies') {
                //Это исключили из интерфейса, поэтому тут нет доработок по пцбличным ws
                const cf = getters.convertfunctions.filter((f) => f.id === object.convert_function)[0]
                const ec = getters.economicModels.filter((f) => f.id === object.economics)[0]
                object.convert_function = cf ? cf.name : object.convert_function
                object.economics = ec ? ec.name : object.economics
                object.point = getters.objectSelected.infrastructure.point
                if (!object.is_placement) {
                  delete object.capacity_rest
                  delete object.capacity_full
                }
                object.infrastructure = { ...getters.objectSelected.infrastructure }
                object.infrastructure.status = object.infrastructure.status ? infrastructureStatuses[object.infrastructure.status] : null
                object.infrastructure.territory = object.infrastructure.territory ? object.infrastructure.territory.name || '-' : '-'
              }

              if (item.type === 'emitter') {
                if (!hiddenFields.includes('counterparty')) {
                  object.counterparty = object.counterparty ? object.counterparty.name || '-' : '-'
                }
                if (!hiddenFields.includes('building')) {
                  object.address = object.building ? object.building.address || '-' : '-'
                }
              }

              if (item.type === 'adm_territory' || item.type === 'dedicated_territory') {
                if (!hiddenFields.includes('oktmo')) {
                  object.oktmo = object.oktmo ? object.oktmo.oktmo_code || '-' : '-'
                }
              }

              if (item.type === 'zone') {
                if (!hiddenFields.includes('territories')) {
                  object.territories = object.territories && object.territories.length > 0 ? object.territories.map((v) => v.name).join(', ') : '-'
                }
              }

              if (item.type === 'flow') {
                if (object.source_infrastructure) {
                  //Система не отдает координаты ОИ, если на линии несколько потоков
                  if (
                    object.infrastructure &&
                    object.infrastructure.point &&
                    Array.isArray(object.infrastructure.point.coordinates) &&
                    object.source_infrastructure.point &&
                    Array.isArray(object.source_infrastructure.point.coordinates)
                  ) {
                    object.bounds = [object.infrastructure.point.coordinates.reverse()]
                    object.bounds.push(object.source_infrastructure.point.coordinates.reverse())
                  }

                  if (!hiddenFields.includes('source_infrastructure')) {
                    object.source_infrastructure = object.source_infrastructure.name
                  }
                }
                delete object.point

                if (object.infrastructure && !hiddenFields.includes('infrastructure')) {
                  object.infrastructure = object.infrastructure.name
                }
                //object.source_infrastructure = object.source_infrastructure ? object.source_infrastructure.name : null
                //object.infrastructure = object.infrastructure ? object.infrastructure.name : null
              }
              if (item.type === 'transfer') {
                object.name = 'Маршрут перевозки №' + object.id
                if (object.sink_flow_infrastructure) {
                  object.sink_flow_infrastructure.status = object.sink_flow_infrastructure.status
                    ? infrastructureStatuses[object.sink_flow_infrastructure.status]
                    : null
                  object.sink_flow_infrastructure.territory = object.sink_flow_infrastructure.territory
                    ? object.sink_flow_infrastructure.territory.name || '-'
                    : '-'
                  object.sink_flow_infrastructure.treatment_output = [1, 2, 3]
                }
                if (object.source_flow_infrastructure) {
                  object.source_flow_infrastructure.status = object.source_flow_infrastructure.status
                    ? infrastructureStatuses[object.source_flow_infrastructure.status]
                    : null
                  object.source_flow_infrastructure.territory = object.source_flow_infrastructure.territory
                    ? object.source_flow_infrastructure.territory.name || '-'
                    : '-'
                }

                object.car = object.car
                  ? object.car.map((v) => {
                      v.name = 'Машина ' + (v.car_type ? v.car_type.name || v.car_type : v.id)
                      v.transport_zones_names =
                        v.car_type && v.car_type.transport_zones_names && v.car_type.transport_zones_names.length
                          ? Array.from(new Set(v.car_type.transport_zones_names)).join(', ')
                          : '-'
                      v.car_type = v.car_type ? v.car_type.name || v.car_type.id || v.car_type : null
                      return v
                    })
                  : null
              }

              const formatCollectingLoopAddress = (addressArr) => {
                return addressArr && addressArr.length > 0 ? addressArr.join(', ') : '-'
              }

              if (item.type === 'removaltrip') {
                object.name = 'Маршрут вывоза №' + object.id
                if (object.infrastructure) {
                  object.infrastructure.territory = object.infrastructure.territory ? object.infrastructure.territory.name || '-' : '-'
                  object.infrastructure.status = object.infrastructure.status ? infrastructureStatuses[object.infrastructure.status] : null
                }
                if (object.car) {
                  object.car.name = 'Машина ' + (object.car.car_type ? object.car.car_type.name || object.car.car_type : object.car.id)
                  object.car.transport_zones_names =
                    object.car.car_type && object.car.car_type.transport_zones_names && object.car.car_type.transport_zones_names.length
                      ? Array.from(new Set(object.car.car_type.transport_zones_names)).join(', ')
                      : '-'
                  object.car.car_type = object.car.car_type ? object.car.car_type.name || object.car.car_type.id || object.car.car_type : null
                }

                if (Array.isArray(object.collecting_loops)) {
                  object.collecting_loops = object.collecting_loops.map((v) => {
                    v.name = 'Петля сбора №' + v.id
                    v.full_address = formatCollectingLoopAddress(v.full_address)
                    return v
                  })
                }
              }
              if (item.type === 'collectingloop') {
                object.name = 'Петля сбора №' + object.id
                if (!hiddenFields.includes('full_address')) {
                  object.full_address = formatCollectingLoopAddress(object.full_address)
                } else {
                  delete object.full_address
                }
              }
              if (item.type === 'streaminfo') {
                object.source_point = object.source_point instanceof Object ? object.source_point.coordinates.join(' ') : object.source_point
                object.sink_point = object.sink_point instanceof Object ? object.sink_point.coordinates.join(' ') : object.sink_point
              }

              //additional_data - массив, который перейдет в long_data на клиенте
              //актуально для зон и территорий
              //В массиве объекты с полями title и value
              if (ENTITIES_WITH_ADDITIONAL_DATA.includes(item.type) && !hiddenFields.includes('additional_data')) {
                object.long_data = object.additional_data
                delete object.additional_data
              }

              if (item.type === 'containerplatform') {
                if (!hiddenFields.includes('addresses')) {
                  object.addresses = object.addresses ? Array.from(new Set(object.addresses)).join('; ') : 'Адреса не указаны'
                } else {
                  delete object.addresses
                }

                const stateMap = {
                  filled: 'Заполняется',
                  not_filled: 'Не заполняется',
                  overflowed: 'Переполняется',
                  planned: 'Планируемый',
                  discarded: 'Списанный'
                }

                if (!hiddenFields.includes('route')) {
                  object.route = JSON.stringify(object.route)
                } else {
                  delete object.route
                }

                if (!hiddenFields.includes('containers')) {
                  object.containers = object.containers || []
                }

                if (!hiddenFields.includes('category_type')) {
                  object.category_type = object.category_type
                    ? getters.emitterCategorytypesMap[object.category_type]
                      ? getters.emitterCategorytypesMap[object.category_type].name
                      : object.category_type + ' - отсутствует в справочнике'
                    : 'Не задана'
                }

                const containerProperties = [
                  {
                    status: 'active',
                    property: 'active_containers'
                  },
                  {
                    status: 'discarded',
                    property: 'discarded_containers'
                  },
                  {
                    status: 'planned',
                    property: 'planned_containers'
                  }
                ]
                containerProperties.forEach((containerStatus) => {
                  object[containerStatus.property] = object.containers
                    .filter((v) => v.status === containerStatus.status)
                    .map((v) => {
                      const containerInfo =
                        v.timetable_data && v.timetable_data.routine_removals
                          ? {
                              ...v,
                              ...v.timetable_data.routine_removals
                            }
                          : v
                      containerInfo.visit_window = containerInfo.visit_window_start
                      containerInfo.visit_window += containerInfo.visit_window ? ' - ' : ''
                      containerInfo.visit_window += containerInfo.visit_window_end
                      containerInfo.name = 'Контейнер №' + containerInfo.id
                      containerInfo.state = stateMap[containerInfo.state]
                      return containerInfo
                    })
                })
              }

              //additional_data - в территориях - объект
              //в КП - массив
              const finalProperties = Array.isArray(object.additional_data)
                ? formatProperties(object).concat(
                    object.additional_data.map((v) => {
                      return {
                        ...v,
                        value: v.type === 'bool' ? (v.value ? 'Есть' : 'Нет') : v.value || '-',
                        type: 'String',
                        isAdditional: true
                      }
                    })
                  )
                : formatProperties(object)

              objectsFormatted.push(finalProperties)
              objectsFormatted.forEach((obj) => {
                obj.sort((a, b) => {
                  return a.title === 'territories' ? 1 : b.title === 'territories' ? -1 : 0
                })
              })
            })

            if (objects.length > 1) {
              objectsFormatted[0] = objectsFormatted[0].map((v) => {
                const idealValue = JSON.stringify(v.value)
                let isCommon = false

                isCommon =
                  objectsFormatted.filter((object) => object.filter((prop) => prop.title === v.title && JSON.stringify(prop.value) === idealValue).length > 0)
                    .length === objects.length
                return {
                  ...v,
                  isCommon
                }
              })
            }
            commit('setRawSelectedObjectInfo', { rawSelectedObjectInfo: r.body })
            commit('setObjectStaticInfo', objectsFormatted)
            commit('setObjectLoadingData', 0)
          })
          .catch((e) => {
            if (e.status === 404) {
              commit('setApiErrorInfo', 'Выбранный объект не существует в заданном периоде')
              commit('setObjectSelected', null)
              commit('setRawSelectedObjectInfo', { rawSelectedObjectInfo: null })
            }
            commit('setObjectLoadingData', 0)
          })
      })
    }
  },
  getObjectDetailsInfo({ getters, commit }, item) {
    commit('setObjectDetailsSelected', null)
    commit('setObjectDetailsInfo', null)

    if (item) {
      let url = ''
      let title = ''
      const params = {
        workspace: getters.workspace,
        version: getters.version,
        [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.allBorders.join(','),
        ids: item.ids.join(',')
      }

      //Получение настройки слоя hideChangingAttributes
      //Если она true, то дополнительные атрибуты слоя скрываются
      let layerId = item.layerId //Надо доработать создание объектов карты чтобы везде был layerId
      //Если layerId нет в данных выбраного объекта то пробуем получить по старому через type и subtype
      //Сейчас layerId приходит если выбрали в левой панели, и не приходит если выбрали на карте
      if (!layerId) {
        layerId = item.type
        if (layerId === 'info' || layerId === 'streaminfo') {
          layerId = `${item.type}-${item.subtype}`
        }
      }
      const layerSettings = getters.objectLayerSettings[layerId]
      const hideChangingAttributes = !!layerSettings && layerSettings.hideChangingAttributes
      if (hideChangingAttributes) {
        return Promise.resolve()
      }

      switch (item.type) {
        case 'infrastructure':
          url = getters.endpoint.objectDetails.infrastructure
          title = item.ids.length > 1 ? 'Объекты инфраструктуры: ' + item.ids.length + ' шт.' : 'Объект инфраструктуры №' + item.ids[0]
          break
        case 'zone':
          if (getters.canEditWs) {
            url = getters.endpoint.objectDetails.zone
            title = 'Зона №' + item.ids[0]
          }
          break
        case 'adm_territory':
          if (getters.canEditWs) {
            url = getters.endpoint.objectDetails.admterritory
            title = 'Административная территория:  №' + item.ids[0]
          }
          break
        case 'dedicated_territory':
          if (getters.canEditWs) {
            url = getters.endpoint.objectDetails.dedicatedterritory
            title = 'Выделенная территория: №' + item.ids[0]
          }
          break
      }
      if (!url) {
        return Promise.resolve()
      }

      commit('setObjectDetailsSelected', {
        params: item,
        title: title
      })
      commit('setObjectLoadingData', 1)
      return Vue.http
        .get(url, {
          params
        })
        .then((r) => {
          const details = r.body
          if (item.type === 'infrastructure') {
            for (let period in details) {
              if (details[period].status) {
                details[period].status = infrastructureStatuses[details[period].status]
              }
            }
          }
          commit('setObjectDetailsInfo', details)
          commit('setObjectLoadingData', 0)
        })
        .catch((e) => {
          commit('setApiError', { error: 'Ошибка загрузки данных по периодам' })
          commit('setObjectLoadingData', 0)
        })
    }
  },

  updateObjectsPeriod({ commit, dispatch }, params) {
    //Установка выбранного периода
    commit('setObjectsPeriod', params)
  },

  /**
   * Действие по сбросу данных раздела "Объекты"
   * @param {*} param0
   * @param {*} params
   */
  totalObjectsReset({ commit, dispatch }, params) {
    //Сброс всех текущих запросов
    Object.keys(requests).forEach((key) => {
      if (requests[key]) {
        dispatch('abortMapRequest', { request: requests[key], key })
      }
    })
    //Сворачивание раскрытых слоев в левой панели
    dispatch('collapseAllLayers')
    //Сброс данных нижней панели (ИЗМЕНЯЮЩИЕСЯ АТРИБУТЫ)
    commit('setObjectDetailsInfo', {})
    //Сброс выбранного объекта
    commit('setObjectSelected', null)
    commit('setRawSelectedObjectInfo', { rawSelectedObjectInfo: null })
    //Сброс данных правой панели (атрибуты выбранного объекта)
    commit('setObjectStaticInfo', [])
    //Сброс дынных слоев для карты
    dispatch('clearLayerMapData')
    //Сброс данных слоев для левой панели
    dispatch('clearLayerLeftPanelData')
    //Сброс выбранного периода
    commit('setObjectsPeriod', null)

    //Сброс раскрасок
    commit('setColoringLayerNames', {
      coloringLayerNames: {}
    })
    commit('setColorings', {
      colorings: {}
    })
    commit('setLayerColorings', {
      layerColorings: {}
    })
    commit('setLayerColoringConnections', {
      layerColoringConnections: {}
    })

    //Сброс словаря скрытых полей
    commit('setFieldsControlDict', null)

    //Сброс привязок
    commit('setPriorityFlows', [])
  },

  /**
   * Формирование настроек и стилей слоев на основе настроек рабочего пространства
   * @param {*} param0
   */
  setLayerSettingsAndStyles({ commit, getters }) {
    const { layerSettings, layerStyles } = getters.settings.front_layer_layout
    let objectLayerSettings = {}
    Object.entries(layerSettings || {}).forEach(([layerId, layerSettingsFromServer]) => {
      const layerType = layerSettingsFactories[layerSettingsFromServer.type] ? layerSettingsFromServer.type : 'default'
      objectLayerSettings[layerId] = layerSettingsFactories[layerType](layerSettingsFromServer)
    })

    if (objectLayerSettings.flow) {
      objectLayerSettings.flow.selectedProblems = objectLayerSettings.flow.selectedProblems || Object.keys(getters.settings.flow_problems_list)
    }

    //Специальный слой для отображения маршрута КП на последний период
    if (!objectLayerSettings[CONTAINER_PLATFORM_ROUTE_LAYER_ID]) {
      objectLayerSettings[CONTAINER_PLATFORM_ROUTE_LAYER_ID] = layerSettingsFactories[CONTAINER_PLATFORM_ROUTE_LAYER_SETTINGS.type](
        CONTAINER_PLATFORM_ROUTE_LAYER_SETTINGS
      )
    }

    //Костыль для treatment_type
    ;['collectingloop', 'transfer', 'removaltrip'].forEach((layerId) => {
      if (objectLayerSettings[layerId]) {
        objectLayerSettings[layerId].mwParams = ['treatment_type']
      }
    })

    commit('setObjectLayerSettings', objectLayerSettings)

    //Здесь надо установить копию исходных настроек стилей
    let layerStylesCopy = JSON.parse(JSON.stringify(layerStyles))

    //Специальные стили для отображения маршрута КП на последний период
    if (!layerStylesCopy || !layerStylesCopy[CONTAINER_PLATFORM_ROUTE_STYLE_ID]) {
      layerStylesCopy[CONTAINER_PLATFORM_ROUTE_STYLE_ID] = CONTAINER_PLATFORM_ROUTE_STYLE
    }
    if (!layerStylesCopy || !layerStylesCopy[CONTAINER_PLATFORM_ROUTE_STYLE_SELECTED_ID]) {
      layerStylesCopy[CONTAINER_PLATFORM_ROUTE_STYLE_SELECTED_ID] = CONTAINER_PLATFORM_ROUTE_STYLE_SELECTED
    }

    //Новый код получения стилей слоев
    commit('setLayerStyles', {
      layerStyles: layerStylesCopy
    })
  },

  /**
   * Очистка данных слоев для левой панели
   */
  clearLayerLeftPanelData({ commit }) {
    commit('clearLayerObjects')
  },

  /**
   * Сброс данных слоев для карты
   */
  clearLayerMapData({ commit }) {
    const data = JSON.parse(JSON.stringify(defaultObjectMapData))
    commit('setMapData', data)
    commit('setObjectMapRequestTime', data)
  },

  /**
   * Загрузка доступных для слоев раскрасок
   * @param {*} param0
   * @returns
   */
  loadLayerColoring({ commit, getters }) {
    commit('setObjectLoadingData', 1)
    return Vue.http
      .get(getters.endpoint.layers, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        /**
         * Словарь слоев у которых есть раскраски
         * ключ - идентификатор
         * значение - название
         */
        let coloringLayerNames = {}
        /**
         * Словарь раскрасок
         */
        let colorings = {
          default: {
            id: 'default',
            name: 'Без покраски'
          }
        }
        /**
         * Распределение раскрасок по слоям
         * Ключ - идентификатор слоя
         * Значение массив идентификаторов раскраски
         */
        let layerColorings = {}
        /**
         * Ключ - идентификатор раскраски
         * значение объект, где ключ - идентификатор слоя, а значение true или false (есть связь или нет связи)
         */
        let layerColoringConnections = {}

        r.body
          .filter(({ name: layerId, coloring: layerColoring }) => {
            return Object.keys(layerColoring).length !== 0 && getters.objectLayerTypes[layerId]
          })
          .forEach(({ name: layerId, label: layerName, coloring: layerColoring }) => {
            //Словарь названий слоев с раскрасками
            coloringLayerNames[layerId] = layerName

            //Добавление раскрасок в словарь
            colorings = {
              ...colorings,
              ...layerColoring
            }

            //Добавление раскрасок слоя
            layerColorings[layerId] = ['default', ...Array.from(Object.keys(layerColoring))]

            //Добавление связей раскрасок
            layerColorings[layerId].forEach((coloringId) => {
              if (!layerColoringConnections[coloringId]) {
                layerColoringConnections[coloringId] = {}
              }
              layerColoringConnections[coloringId][layerId] = true
            })
          })

        commit('setColoringLayerNames', {
          coloringLayerNames: coloringLayerNames
        })

        commit('setColorings', {
          colorings: colorings
        })

        commit('setLayerColorings', {
          layerColorings: layerColorings
        })

        commit('setLayerColoringConnections', {
          layerColoringConnections: layerColoringConnections
        })
      })
      .finally((e) => {
        commit('setObjectLoadingData', 0)
      })
  },

  getMapData({ dispatch, getters }) {
    if (getters.objectMapParams && getters.objectsPeriod && getters.objectsPeriod.borders) {
      const params = {
        zoom: getters.objectMapParams.zoom
      }
      if (getters.objectMapParams.zoom >= getters.settings.bbox_min_zoom) {
        params.square = getters.objectMapParams.square
      }
      if (!getters.token && getters.objectPublicFilters && getters.objectPublicFilters.length > 0) {
        params.active_filters = getters.objectPublicFilters.join(',')
      }

      const layers = ['emitter', 'transportbase', 'source', 'flow', 'infrastructure', 'containerplatform', 'zonegroup', 'route', 'building']

      layers.forEach((layerType) => {
        const mapParams = { type: layerType, params }
        if (!getters.objectZoneGroupMode && layerType === 'zonegroup') {
          mapParams.isFull = 1
        }
        dispatch('getObjectMap', mapParams)
      })
      const infoLayers = ['info', 'streaminfo']
      infoLayers.forEach((layerType) => {
        getters.getLayerSettingsByParentId(layerType).forEach((layerSettings) => {
          dispatch('getObjectMap', {
            type: layerType,
            params,
            layerId: layerSettings.serverId,
            //Такой странное название так как в действии getObjectMap параметр layerId уже занят
            layerSettingsId: layerSettings.id
          })
        })
      })
    }
  },
  reset3dMapQuery({ getters, commit }, layerName) {
    const requestName = `${layerName}3D`

    if (requests[requestName]) {
      requests[requestName].abort()
      requests[requestName] = null
    }
    commit('update3DMapData', {
      [layerName]: null
    })
  },
  get3DMapData({ dispatch }) {
    ;['source', 'flow', 'infrastructure'].forEach((layerType) => {
      const params = { type: layerType }
      dispatch('getObject3DMap', params)
    })
  },
  getMapDataByLayoutType({ dispatch, getters }, params) {
    if (!getters.objectsPeriod || !getters.objectsPeriod.borders) {
      return Promise.resolve()
    }

    let requestParams = {
      type: params.type
    }

    if (['zoneGroupColors', 'infrastructureColors'].includes(params.type)) {
      return dispatch('getObjectMap', requestParams)
    }
    if (getters.objectMapParams) {
      const mapParams = {
        zoom: getters.objectMapParams.zoom
      }

      requestParams.params = mapParams

      if (getters.objectMapParams.zoom >= getters.settings.bbox_min_zoom) {
        requestParams.params.square = getters.objectMapParams.square
      }

      if (!getters.token && getters.objectPublicFilters && getters.objectPublicFilters.length > 0) {
        requestParams.params.active_filters = getters.objectPublicFilters.join(',')
      }

      if (params.type === 'info' || params.type === 'streaminfo') {
        if (params.id) {
          dispatch('getObjectMap', {
            type: params.type,
            params: mapParams,
            layerId: params.id,
            layerSettingsId: params.layerSettingsId
          })
        } else {
          getters.getLayerSettingsByParentId(params.type).forEach((layerSettings) => {
            dispatch('getObjectMap', {
              type: params.type,
              params: mapParams,
              layerId: layerSettings.serverId,
              layerSettingsId: layerSettings.id
            })
          })
        }
      } else {
        dispatch('getObjectMap', requestParams)
      }
    }
  },

  // layers - если обновить надо только отдельные слои, удобно после изменений в группах зон
  getAllLayers({ commit, getters, dispatch }, { layersToUpdate = null } = {}) {
    commit('setObjectLoadingData', 1)
    const level = getters.flowSelectedLevel
    const problems = getters.flowSelectedProblems

    let requestParams = {
      is_panel: true, //Дополнительный параметр, чтобы игнорировать скрытые поля и корректно отображать названия
      [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.borders.join(','),
      workspace: getters.workspace,
      version: getters.version,
      problems: problems ? problems.join(',') : null
    }

    const transportTypes = getters.flowSelectedTransportTypes
    if (Array.isArray(transportTypes)) {
      requestParams.transport_types = transportTypes.join(',')
    }

    if (level && level.length === 1) {
      requestParams.level = level[0]
    }

    if (Array.isArray(layersToUpdate) && layersToUpdate.length > 0) {
      requestParams.entities = layersToUpdate.join(',')
    }

    return Vue.http
      .get(getters.endpoint.allLayers, {
        params: {
          ...getters.objectFilterRequestParams,
          ...requestParams
        },
        before(request) {
          dispatch('abortMapRequest', { request, key: 'all' })
        }
      })
      .then((r) => {
        requests.all = null
        commit('setObjectLoadingData', 0)
        const layers = r.body

        Object.entries(layers).forEach(([layerId, initialLayerDataFromServer]) => {
          if (initialLayerDataFromServer.error) {
            return
          }

          if (layersToUpdate && layersToUpdate.indexOf(layerId) === -1) {
            return
          }

          //Специальная обработка территориального деления
          if (layerId === 'zonegroup') {
            dispatch('setInitialZonegroupStructure', {
              layerId,
              zonegroupServerData: initialLayerDataFromServer,
              zonegroupInfoServerData: layers.zonegroup_info
            })
            return
          }

          //Специальная обработка инфослоев
          if (layerId === 'infolayers') {
            dispatch('prepareInfoLayerSettings', {
              infoLayers: initialLayerDataFromServer
            })
            return
          }

          //Специальная обработка слоев по объектам инфраструктуры
          if (layerId === 'infrastructure') {
            dispatch('prepareInfrastructureLayerSettings', {
              layerId,
              infrastructureLayerData: initialLayerDataFromServer
            })
            return
          }

          //Обработка стандартных слоев
          dispatch('updateDefaultLayerObjects', {
            layerId: LAYER_ID_BY_LAYERLOAD_ENTITY[layerId] || layerId, //Для некоторых слоев название в layerLoad и в настройка отличается
            layerObjectsFromServer: initialLayerDataFromServer,
            clear: true //Здесь будем очищать объекты
          })
        })

        return r
      })
      .catch((e) => {
        console.log(e)
        commit('setObjectLoadingData', 0)
        dispatch('handleMapErros', e)
        if (e.status !== 0) {
          throw e
        }

        return {
          aborted: true
        }
      })
  },

  getObjectMap({ commit, getters, dispatch }, params) {
    let layerType = params.type

    if (getters.objectLayerSettings[layerType] && getters.objectLayerSettings[layerType].hide) {
      return Promise.resolve()
    }

    if (['borders', 'zones', 'info', 'streaminfo', 'streaminfoRoute', 'zoneGroupColors', 'infrastructureColors'].indexOf(layerType) === -1) {
      //Проверка видимости слоев с указанным источником данных
      const dataSourceVisibility = getters.getDataSourceVisibility(layerType)
      if (!dataSourceVisibility) {
        return Promise.resolve()
      }
    }

    //По новой структуре
    const layerSettingsId = params.layerSettingsId
    const layerVisibility = getters.getLayerVisibility(layerSettingsId)
    //Если инфослой скрыт то ничего не запрашиваем
    if (['info', 'streaminfo'].indexOf(layerType) > -1 && !layerVisibility) {
      return Promise.resolve()
    }

    if (['source', 'flow'].indexOf(layerType) > -1 && getters.getSelectedAdmLevel === -1) {
      return Promise.resolve()
    }

    const firstVisibleAdmLevelLayerSettings = getters.getFirstVisibleAdmLevelLayerSettings
    if (['borders', 'zones', 'zonegroup'].indexOf(layerType) > -1 && !firstVisibleAdmLevelLayerSettings) {
      return Promise.resolve()
    }

    if (
      ['streaminfoRoute'].indexOf(layerType) > -1 &&
      (!getters.objectSelected ||
        getters.objectSelected.type !== 'streaminfo' ||
        !getters.showRouteForSelectedStreaminfoObject ||
        !(getters.objectLayerSettings[`${getters.objectSelected.type}-${getters.objectSelected.subtype}`] || {}).isTrip)
    ) {
      return Promise.resolve()
    }
    let requestKey = layerType

    const flows = getters.objectLayerSettings.flow

    const requestParams = {
      ...params.params,
      workspace: getters.workspace,
      version: getters.version
    }
    delete requestParams.isFull
    const lastPeriodBorder = getters.objectsPeriod.allBorders[getters.objectsPeriod.allBorders.length - 1]

    if (['info', 'streaminfo'].indexOf(layerType) > -1) {
      requestParams.id = params.layerId
      requestKey += `-${params.layerId}`
    } else {
      requestParams[getters.objectsPeriod.scaleType.id] = getters.objectsPeriod.borders.join(',')
    }
    if (
      getters.objectLayerSettings[layerType] &&
      getters.objectLayerSettings[layerType].selectedColor &&
      getters.objectLayerSettings[layerType].selectedColor !== 'default'
    ) {
      requestParams.color = getters.objectLayerSettings[layerType].selectedColor
    }
    if (['emitter', 'infrastructure', 'route', 'source', 'flow'].indexOf(layerType) > -1 && getters.objectWasteSelected !== 'all') {
      requestParams.waste_type = getters.objectWasteSelected
    }
    if (layerType === 'flow' && getters.objectWasteSelected === 'all') {
      requestParams.item_ratio = 'all'
    }
    if (['infrastructure'].indexOf(layerType) > -1) {
      delete requestParams.zoom
    }
    if (['infrastructure', 'route', 'source', 'flow'].indexOf(layerType) > -1 && getters.objectTreatmentSelected) {
      requestParams.treatment_type = getters.objectTreatmentSelected
    }
    if (layerType === 'route' && getters.showRouteForContainerPlatform) {
      requestParams.container_platform = getters.showRouteForContainerPlatform
      requestParams[getters.objectsPeriod.scaleType.id] = `${lastPeriodBorder},${lastPeriodBorder}`
    }
    if (layerType === 'streaminfoRoute' && getters.showRouteForSelectedStreaminfoObject) {
      delete requestParams[getters.objectsPeriod.scaleType.id]
      requestParams.id = getters.objectSelected.subtype
      requestParams.obj_ids = getters.objectSelected.ids.join(',')
    }

    //Специальные параметры для потоков и источников
    if (['source', 'flow'].indexOf(layerType) > -1) {
      //Уровень административного деления
      requestParams.adm_level = flows.selectedTerritory ? flows.selectedTerritory.admLevel : getters.getSelectedAdmLevel
      if (flows.selectedTerritory && flows.selectedTerritory.allPeriods) {
        requestParams[getters.objectsPeriod.scaleType.id] = `${lastPeriodBorder},${lastPeriodBorder}`
      }

      //Проблемы. Передаем параметр problem = список проблем через запятую
      const flowLayerSettings = getters.objectLayerSettings.flow
      const problemArray = flowLayerSettings ? flowLayerSettings.selectedProblems || [] : []
      requestParams.problem = problemArray.join(',')
      //Типы транспорта (ОПВК)
      const transportTypes = flowLayerSettings ? flowLayerSettings.selectedTransportTypes || null : null
      if (Array.isArray(transportTypes)) {
        requestParams.transport_types = transportTypes.join(',')
      }

      //Для потоков и источников убираем параметры zoom и square согласно задаче https://app.clickup.com/t/2unhpqb
      delete requestParams.zoom
      delete requestParams.square
    }

    if (['borders', 'zones', 'zonegroup'].indexOf(layerType) > -1) {
      requestParams.adm_level = firstVisibleAdmLevelLayerSettings.admLevel
    }

    commit('setObjectLoadingData', 1)
    return Vue.http
      .get(getters.endpoint.map[layerType], {
        params: requestParams,
        before(request) {
          dispatch('abortMapRequest', { request, key: requestKey })
        }
      })
      .then((r) => {
        requests[requestKey] = null
        let value = r.body
        const additionalValues = {}
        if (layerType === 'streaminfoRoute') {
          value = value.result || null
        }
        if (params.layerId) {
          value = {
            ...getters.objectMapData[layerType],
            [params.layerId]: value
          }
        }
        const updatedData = {
          ...additionalValues,
          [layerType]: value
        }
        commit('updateMapData', updatedData)
        commit('setObjectMapRequestTime', updatedData)

        commit('setObjectLoadingData', 0)
      })
      .catch((e) => {
        commit('setObjectLoadingData', 0)
        dispatch('handleMapErros', e)
      })
  },

  getObject3DMap({ commit, getters, dispatch }, params) {
    const layerType = params.type
    if (getters.objectLayerSettings[layerType].hide) {
      return Promise.resolve()
    }

    if (layerType === 'flow' && getters.getSelectedAdmLevel === -1) {
      return Promise.resolve()
    }

    let requestKey = `${layerType}3D`

    const flows = getters.objectLayerSettings.flow

    const requestParams = {
      zoom: 10,
      workspace: getters.workspace,
      version: getters.version,
      [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.borders.join(',')
    }

    if (
      getters.objectLayerSettings[layerType] &&
      getters.objectLayerSettings[layerType].selectedColor &&
      getters.objectLayerSettings[layerType].selectedColor !== 'default'
    ) {
      requestParams.color = getters.objectLayerSettings[layerType].selectedColor
    }
    if (['infrastructure', 'source', 'flow'].indexOf(layerType) > -1 && getters.objectWasteSelected !== 'all') {
      requestParams.waste_type = getters.objectWasteSelected
    }
    if (layerType === 'flow' && getters.objectWasteSelected === 'all') {
      requestParams.item_ratio = 'all'
    }
    if (['infrastructure', 'source', 'flow'].indexOf(layerType) > -1 && getters.objectTreatmentSelected) {
      requestParams.treatment_type = getters.objectTreatmentSelected
    }
    if (['source', 'flow'].indexOf(layerType) > -1) {
      requestParams.adm_level = flows.selectedTerritory ? flows.selectedTerritory.admLevel : getters.getSelectedAdmLevel
      if (flows.selectedTerritory && flows.selectedTerritory.allPeriods) {
        requestParams[getters.objectsPeriod.scaleType.id] = getters.objectsPeriod.allBorders.join(',')
      }
    }
    commit('setObjectLoadingData', 1)
    return Vue.http
      .get(getters.endpoint.map[layerType], {
        params: requestParams,
        before(request) {
          dispatch('abortMapRequest', { request, key: requestKey })
        }
      })
      .then((r) => {
        requests[requestKey] = null
        let value = r.body
        const additionalValues = {}
        commit('update3DMapData', {
          ...additionalValues,
          [layerType]: value
        })

        commit('setObjectLoadingData', 0)
      })
      .catch((e) => {
        commit('setObjectLoadingData', 0)
        dispatch('handleMapErros', e)
      })
  },

  getInfrastructurePanel({ commit, getters, dispatch }) {
    if (!getters.settings.infrastructure_type) {
      return Promise.resolve()
    }
    commit('setObjectLoadingData', 1)
    return Vue.http
      .get(getters.endpoint.infrastructure, {
        params: {
          limit: 2000,
          offset: 0,
          ...getters.objectFilterRequestParams,
          fields: 'id,name,status,rank',
          workspace: getters.workspace,
          version: getters.version,
          [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.borders.join(',')
        }
      })
      .then((r) => {
        dispatch('prepareInfrastructureLayerSettings', {
          layerId: 'infrastructure',
          infrastructureLayerData: r.body
        })
        commit('setObjectLoadingData', 0)
      })
      .catch((e) => {
        commit('setObjectLoadingData', 0)
      })
  },
  getContainerTypes({ commit, getters }) {
    commit('setObjectLoadingData', 1)
    return Vue.http
      .get(getters.endpoint.containertype, {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          limit: 2000
        }
      })
      .then((r) => {
        let types = r.body.results || []
        types = types.map((v) => {
          let name = v.material ? v.material + ': ' : ''
          name += (v.volume || '') + (v.volume_designation || '')
          return {
            ...v,
            name
          }
        })
        commit('setObjectContainerTypes', convertArrayToObject(types, 'id'))
        commit('setObjectLoadingData', 0)
      })
      .catch((e) => {
        commit('setObjectLoadingData', 0)
      })
  },

  getTerritoriesPanel({ commit, getters, dispatch }) {
    if (!getters.admLevels) {
      return Promise.resolve()
    }
    commit('setObjectLoadingData', 1)
    return Vue.http
      .get(getters.endpoint.zonegroups, {
        params: {
          ...getters.objectFilterRequestParams,
          workspace: getters.workspace,
          version: getters.version,
          fields: 'id,adm_levels,name,default,operator_zone',
          [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.borders.join(',')
        }
      })
      .then((r) => {
        dispatch('processTerritoriesPanelResults', { response: r.body })
        commit('setObjectLoadingData', 0)
      })
      .catch((e) => {
        commit('setObjectLoadingData', 0)
      })
  },
  processTerritoriesPanelResults({ commit, getters }, params) {
    const childrenLayer = []
    const childrenLayerInfo = {}
    const defaultVisibility = getters.objectLayerSettings.zonegroup.isVisible

    let r = params.response.results
      .map((v) => {
        return {
          ...v,
          adm_levels: v.adm_levels.length > 0 ? v.adm_levels.sort((a, b) => a - b) : [20]
        }
      })
      .sort((a, b) => {
        return a.default ? -1 : 0
      })
    if (!getters.canEditWs && getters.objectLayerSettings.zonegroup.hidePublicTransport) {
      r = r.filter((v) => !v.operator_zone)
    }

    if (r.length === 0) {
      commit('setObjectLoadingData', 0)
      return
    }

    let defaultSelectedIndex = r.findIndex((zonegroup) => zonegroup.default)
    defaultSelectedIndex = defaultSelectedIndex > -1 ? defaultSelectedIndex : 0

    //const territoriesSettings = getters.objectAvailableLayers.zonegroup
    const oldAdmLevelSettings = getters.objectLayerSettings.zonegroup.adm_level
    let newAdmLevelSettings = -1
    const territoriesChildren = getters.objectLayerItems.zonegroup.childrenInfo
    r.forEach((v, i) => {
      childrenLayer.push({
        id: v.id,
        path: v.id,
        parentType: 'zonegroup',
        children: v.adm_levels
          ? v.adm_levels.map((m) => {
              return {
                id: m,
                path: v.id + '-' + m,
                parents: [v.id],
                parentType: 'zonegroup',
                children: []
              }
            })
          : []
      })
      childrenLayerInfo[v.id] = {
        ...v,
        name: v.name || 'Группа зон с id = ' + v.id,
        count: v.adm_levels.length,
        default: v.default,
        zoneVisibility: territoriesChildren[v.id] ? territoriesChildren[v.id].zoneVisibility : true,
        visibility: i === defaultSelectedIndex,
        childrenDraggable: false,
        color: territoriesSettings && territoriesSettings.coloring,
        selectedColor: territoriesSettings && territoriesSettings.coloring ? territoriesSettings.coloring[0].id : null
      }
      if (i === defaultSelectedIndex) {
        newAdmLevelSettings =
          oldAdmLevelSettings && getters.admLevelsMap[oldAdmLevelSettings] && v.adm_levels.filter((m) => m === oldAdmLevelSettings).length > 0
            ? oldAdmLevelSettings
            : v.defaultAdmLevel || childrenLayer[defaultSelectedIndex].children[0].id
      }
      v.adm_levels.forEach((m) => {
        childrenLayerInfo[v.id + '-' + m] = {
          name: getters.admLevelsMap[m],
          id: m,
          zoneVisibility:
            i === defaultSelectedIndex
              ? m >= newAdmLevelSettings
              : territoriesChildren[v.id + '-' + m]
              ? territoriesChildren[v.id + '-' + m].zoneVisibility
              : true,
          visibility: i === defaultSelectedIndex && m >= newAdmLevelSettings,
          childrenDraggable: false
        }
      })
    })
    commit('updateObjectItems', {
      zonegroup: {
        count: childrenLayer.length,
        children: childrenLayer,
        childrenInfo: childrenLayerInfo,
        objectsInfo: {}
      }
    })
    commit('updateObjectLayerSettings', {
      zonegroup: {
        ...getters.objectLayerSettings.zonegroup,
        zoneGroup: getters.objectZoneGroupMode ? -1 : childrenLayer[defaultSelectedIndex].id,
        // zoneGroup: childrenLayer[defaultSelectedIndex].id,
        adm_level: newAdmLevelSettings
      }
    })
    /*r.forEach(zonegroup => {
      zonegroup.adm_levels.forEach(level => {
        dispatch('getZonesPanel', {zonegroup: zonegroup.id, adm_level: level})
      })
    })*/
  },
  getZonesPanel({ commit, getters, dispatch }, params) {
    commit('setObjectLoadingData', 1)
    Vue.http
      .get(getters.endpoint.zonegroup(params.zonegroup), {
        params: {
          ...getters.objectFilterRequestParams,
          workspace: getters.workspace,
          version: getters.version,
          [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.borders.join(','),
          adm_level: params.adm_level,
          fields: 'id,zones,name'
        }
      })
      .then((r) => {
        dispatch('processZonesPanelResults', {
          response: r.body,
          adm_level: params.adm_level,
          zonegroup: params.zonegroup,
          zone: params.zone
        })
        commit('setObjectLoadingData', 0)
      })
      .catch((e) => {
        commit('setObjectLoadingData', 0)
      })
  },
  processZonesPanelResults({ commit, getters, dispatch }, params) {
    const newLayerChildren = JSON.parse(JSON.stringify(getters.objectLayerItems.zonegroup.children))
    const indexGroup = newLayerChildren.findIndex((v) => v.id === params.zonegroup)
    const group = newLayerChildren[indexGroup]
    const levelIndex = group.children.findIndex((v) => v.id === params.adm_level)
    const level = group.children[levelIndex]
    level.count = params.response.zones.length

    const defaultVisibility = getters.objectLayerItems.zonegroup.childrenInfo[group.id + '-' + level.id].visibility
    const defaultZoneVisibility = getters.objectLayerItems.zonegroup.childrenInfo[group.id + '-' + level.id].zoneVisibility
    let newZonesLayer = params.response.zones.map((v) => {
      let currentObjects = []
      if (params.zone) {
        currentObjects = level.children.filter((zone) => zone.id === v.id)
        currentObjects = currentObjects.length > 0 ? currentObjects[0].objects : []
      }
      return {
        id: v.id,
        path: group.id + '-' + level.id + '-' + v.id,
        count: currentObjects.length,
        parents: [group.id, group.id + '-' + level.id],
        parentType: 'zonegroup',
        objects: currentObjects
      }
    })
    level.children = newZonesLayer

    const childrenLayerInfo = {}
    params.response.zones.forEach((v) => {
      const old = getters.objectLayerItems.zonegroup.childrenInfo[group.id + '-' + level.id + '-' + v.id]
      childrenLayerInfo[group.id + '-' + level.id + '-' + v.id] = {
        ...v,
        color: old ? old.color : null,
        selectable: true,
        type: 'zone',
        count: old ? old.count : -1,
        canToggleItemsVisibility: getters.objectLayerSettings.zonegroup.canToggleItemsVisibility,
        visibility: defaultVisibility,
        zoneVisibility: defaultZoneVisibility
      }
    })
    commit('updateObjectItems', {
      zonegroup: {
        ...getters.objectLayerItems.zonegroup,
        children: newLayerChildren,
        childrenInfo: {
          ...getters.objectLayerItems.zonegroup.childrenInfo,
          ...childrenLayerInfo
        }
      }
    })

    /*params.response.zones.forEach(v => {
      if(!params.zone || params.zone === v.id) {
        dispatch('getZoneRegionsPanel', {zone: v.id, adm_level: params.adm_level, zonegroup: params.zonegroup})
      }
    })*/
    if (params.zone) {
      params.response.zones.forEach((zone) => {
        dispatch('getZoneRegionsPanel', { zone: zone.id, adm_level: params.adm_level, zonegroup: params.zonegroup })
      })
    }
  },
  getZoneRegionsPanel({ commit, getters, dispatch }, params) {
    commit('setObjectLoadingData', 1)
    Vue.http
      .get(getters.endpoint.zone(params.zone), {
        params: {
          ...getters.objectFilterRequestParams,
          workspace: getters.workspace,
          version: getters.version,
          [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.borders.join(','),
          adm_level: params.adm_level,
          fields: 'id,territories,name,color,group'
        }
      })
      .then((r) => {
        dispatch('processZoneRegionsPanelResults', {
          response: r.body,
          adm_level: params.adm_level,
          zone: params.zone,
          zonegroup: params.zonegroup
        })
        commit('setObjectLoadingData', 0)
      })
      .catch((e) => {
        commit('setObjectLoadingData', 0)
      })
  },
  processZoneRegionsPanelResults({ commit, getters }, params) {
    const newLayerChildren = [].concat(getters.objectLayerItems.zonegroup.children)
    const indexGroup = newLayerChildren.findIndex((v) => v.id === params.zonegroup)
    const group = newLayerChildren[indexGroup]
    const levelIndex = group.children.findIndex((v) => v.id === params.adm_level)
    const level = group.children[levelIndex]
    const zoneIndex = level.children.findIndex((v) => v.id === params.zone)
    const zone = zoneIndex > -1 ? level.children[zoneIndex] : null

    const zonegroupChildren = getters.objectLayerItems.zonegroup.childrenInfo

    const defaultVisibility =
      zonegroupChildren[params.zonegroup + '-' + params.adm_level].visibility &&
      zonegroupChildren[params.zonegroup + '-' + params.adm_level + '-' + params.zone].visibility
    const defaultZoneVisibility =
      zonegroupChildren[params.zonegroup + '-' + params.adm_level].zoneVisibility &&
      zonegroupChildren[params.zonegroup + '-' + params.adm_level + '-' + params.zone].zoneVisibility
    const type = params.adm_level < 20 ? 'adm_territory' : 'dedicated_territory'
    if (zone) {
      zone.count = params.response.territories.length
      zone.objects = params.response.territories.map((v) => type + '-' + v.id)
    }
    const allTerritories = Object.keys(getters.objectLayerItems.zonegroup.objectsInfo)
    let oldRegions = allTerritories.filter(
      (v) =>
        getters.objectLayerItems.zonegroup.objectsInfo[v].admLevel === params.adm_level &&
        getters.objectLayerItems.zonegroup.objectsInfo[v].info[params.response.group] &&
        getters.objectLayerItems.zonegroup.objectsInfo[v].info[params.response.group].indexOf(params.zone) > -1
    )

    const objectsLayerInfo = params.response.territories.map((v) => {
      const oldObject = getters.objectLayerItems.zonegroup.objectsInfo[type + '-' + v.id]
      const oldInfo = oldObject ? oldObject.info : {}
      const groupInfo = oldInfo[params.response.group] || []
      groupInfo.push(params.zone)
      return {
        ...v,
        path: type + '-' + v.id,
        adm_level: v.adm_level || 20,
        type,
        info: {
          ...oldInfo,
          [params.response.group]: Array.from(new Set(groupInfo))
        },
        visibility: oldObject ? oldObject.visibility && defaultVisibility : defaultVisibility,
        zoneVisibility: oldObject ? oldObject.zoneVisibility && defaultZoneVisibility : defaultZoneVisibility
      }
    })
    const newTerritories = objectsLayerInfo.map((v) => v.id)
    oldRegions = oldRegions.filter((v) => newTerritories.indexOf(v) === -1)
    oldRegions.forEach((v) => {
      const newInfo = { ...getters.objectLayerItems.zonegroup.objectsInfo[v].info }
      newInfo[params.response.group] = newInfo[params.response.group].filter((zone) => zone !== params.zone)
      objectsLayerInfo.push({
        ...getters.objectLayerItems.zonegroup.objectsInfo[v],
        info: newInfo
      })
    })
    const zonePath = params.zonegroup + '-' + params.adm_level + '-' + params.zone

    commit('updateObjectItems', {
      zonegroup: {
        ...getters.objectLayerItems.zonegroup,
        children: newLayerChildren,
        childrenInfo: {
          ...getters.objectLayerItems.zonegroup.childrenInfo,
          [zonePath]: {
            ...getters.objectLayerItems.zonegroup.childrenInfo[zonePath],
            color: params.response.color
          }
        },
        objectsInfo: {
          ...getters.objectLayerItems.zonegroup.objectsInfo,
          ...convertArrayToObject(objectsLayerInfo, 'path')
        }
      }
    })
  },

  getObjectsMapCache({ commit, dispatch, getters }) {
    return Vue.http
      .get(getters.endpoint.mapCache, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        },
        before(request) {
          dispatch('abortMapRequest', { request, key: 'cache' })
        }
      })
      .then((r) => {
        requests.cache = null
        for (let key in r.body) {
          if (r.body[key]) {
            r.body[key] = new Date(r.body[key]).getTime()
          }
        }
        r.body.territories = r.body.zonegroup
        delete r.body.zonegroup
        commit('setObjectMapCacheUpdated', r.body)
      })
      .catch((e) => {
        dispatch('handleMapErros', e)
      })
  },

  abortMapRequest({}, params) {
    if (requests[params.key]) {
      requests[params.key].abort()
    }
    requests[params.key] = params.request
  },

  handleMapErros({}, e) {
    if (e.status === 0) {
      return
    }
    throw e
  },
  // wastes
  getWasteTypes({ getters, commit }) {
    return Vue.http
      .get(getters.endpoint.wastes, {
        params: {
          limit: 2000,
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        const results = r.body.results.map((v) => {
          return {
            ...v,
            rules: v.rules.map((rule) => {
              return {
                ...rule,
                value: rule.min_mass_percent
              }
            })
          }
        })
        commit('setObjectWastes', results)
      })
      .catch((e) => {})
  },
  updateWasteRule({ getters, commit, dispatch }, params) {
    return Vue.http
      .put(getters.endpoint.wasteRuleById(params.wasteTypeId), params.params, {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.borders.join(',')
        },
        before(request) {
          dispatch('abortMapRequest', { request, key: 'rule' })
        }
      })
      .then((r) => {
        const results = JSON.parse(JSON.stringify(getters.objectWastes))
        const index = results.findIndex((v) => v.id === params.wasteTypeId)
        if (index > -1) {
          results[index] = {
            ...r.body,
            rules: r.body.rules.map((rule) => {
              return {
                ...rule,
                value: rule.min_mass_percent
              }
            })
          }
        }
        commit('setObjectWastes', results)
      })
      .catch((e) => {
        dispatch('handleMapErros', e)
      })
  },

  getFilterList({ getters, commit }) {
    return Vue.http
      .get(getters.endpoint.filters, {
        params: {
          limit: 2000,
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        commit('setObjectFilterList', r.body.results)
        return r.body
      })
      .catch((e) => {})
  },

  getFilterDict({ getters, commit }) {
    return Vue.http
      .get(getters.endpoint.filterDict, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        commit('setObjectFilterDict', r.body)
        return r.body
      })
  },

  addFilter({ getters, commit, dispatch }, params) {
    return Vue.http
      .post(getters.endpoint.filters, params, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        dispatch('getFilterList')
      })
  },
  updateFilter({ getters, commit, dispatch }, params) {
    return Vue.http
      .put(
        getters.endpoint.filterById(params.id),
        { ...params.params },
        {
          params: {
            workspace: getters.workspace,
            version: getters.version
          }
        }
      )
      .then((r) => {
        if (!params.skipUpdate) {
          const newFilters = [...getters.objectFilterList]
          const index = newFilters.findIndex((v) => v.id === params.id)
          newFilters.splice(index, 1, r.body)
          commit('setObjectFilterList', newFilters)
        }
      })
  },
  removeFilter({ getters, dispatch }, id) {
    return Vue.http
      .delete(getters.endpoint.filterById(id), {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        dispatch('getFilterList')
      })
  },
  switchOffAllFilters({ getters, dispatch }) {
    // should be post/put
    return Vue.http
      .get(getters.endpoint.filtersSwitchOff, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        dispatch('getFilterList')
      })
  },

  changeFilters({ getters, commit, dispatch }, params) {
    return Vue.http
      .post(getters.endpoint.filters, params, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {})
  },

  objectPartialUpdate({ commit, dispatch, getters }, params) {
    let url = getters.endpoint.entities[params.type]
    switch (params.type) {
      case 'info':
        url = getters.endpoint.excelLayers.deleteLayer
        break
      case 'streaminfo':
        url = getters.endpoint.excelLayers.deleteLayer
        break
      case 'dedicated_territory':
        url = getters.endpoint.separateterritory
        break
      case 'adm_territory':
        url = getters.endpoint.admterritory
        break
      case 'zone':
        url = getters.endpoint.zones
        break
      case 'zonegroup':
        url = getters.endpoint.zonegroups
        break
    }
    const id = (params.id + '').split('-').reverse()[0]
    let customParams = {}
    const request = Object.keys(params.request).reduce((request, key) => {
      const value = params.request[key]
      key = key.replace('_representation', '')
      request[key] = value
      return request
    }, {})

    if (params.type !== 'streaminfo' && params.type !== 'info') {
      url = `${url}${id}/`
    } else {
      customParams = {
        id: params.subtype,
        obj_ids: params.id
      }
    }
    return Vue.http
      .patch(
        url,
        { ...request },
        {
          params: {
            workspace: getters.workspace,
            version: getters.version
          }
        }
      )
      .then((r) => {
        dispatch('setObjectSelected', getters.objectSelected)
      })
  },

  objectDeleteEntity({ getters, commit, dispatch }, params) {
    let url = getters.endpoint.entities[params.type]
    switch (params.type) {
      case 'dedicated_territory':
        url = getters.endpoint.separateterritory
        break
      case 'adm_territory':
        url = getters.endpoint.admterritory
        break
    }
    url = `${url}${params.id}/`
    return Vue.http
      .delete(url, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((r) => {
        const complexLayersMap = {
          infrastructure: 'infrastructure',
          dedicated_territory: 'zonegroup',
          adm_territory: 'zonegroup'
        }

        let listPromise = Promise.resolve()

        if (complexLayersMap[params.type]) {
          listPromise = dispatch('getAllLayers', [complexLayersMap[params.type]])
        } else {
          listPromise = dispatch('loadLayerObjects', { layerId: params.type, isNext: false })
        }
        if (getters.objectSelected) {
          dispatch('setObjectSelected', { ...getters.objectSelected })
        }
        const typeMap = {
          dedicated_territory: 'zonegroup',
          zone: 'zonegroup',
          adm_territory: 'zonegroup'
        }
        const mapParams = {
          type: typeMap[params.type] || params.type
        }
        if (params.type === 'info' || params.type === 'streaminfo') {
          mapParams.id = params.subtype
        }
        dispatch('getMapDataByLayoutType', mapParams)

        return listPromise
      })
  },

  /**
   * Сброс поля сущности
   * @param {*} param0
   * @param {*} param1
   * @returns
   */
  resetEntityField({ getters }, { entity, field }) {
    return Vue.http.post(
      getters.endpoint.resetField,
      {
        entity,
        field
      },
      {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      }
    )
  },

  /**
   * Скрыть поле у сущности
   * @param {*} param0
   * @param {*} payload
   * @param {*} payload.name название сущности
   * @param {*} payload.field название поля сущности
   * @param {*} payload.object_id идентификатор объекта, передаем, если поле надо скрыть у конкретного объекта
   * @returns
   */
  hideEntityField({ commit, getters }, { name, field, object_id }) {
    let bodyParams = {
      name: name,
      field
    }

    //Костыль для адреса отходообразователей
    if (name === 'emitter' && field === 'address') {
      bodyParams.field = 'building'
    }

    //Костыль для дополнительной информации по зонам
    if (name === 'zone' && field === 'long_data') {
      bodyParams.field = 'additional_data'
    }

    //Костыль корректировка названия сущности для территорий
    if (name === 'adm_territory') {
      bodyParams.name = 'admterritory'
    }

    if (object_id) {
      bodyParams.object_id = object_id
    }

    return Vue.http
      .put(getters.endpoint.fieldsControl, bodyParams, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((response) => {
        //После изменения словаря скрытых полей надо его перезаписать
        commit('setFieldsControlDict', response.body)
      })
  },

  loadCarTypes({ getters }) {
    return Vue.http.get(getters.endpoint.cartype, {
      params: {
        workspace: getters.workspace,
        version: getters.version,
        limit: 10000 //Вряд-ли будет 10000 типов машин? Это нужно чтобы обойти дефолтный лимит бэка в 100
      }
    })
  },

  updateCarType({ getters }, { id, changedFields }) {
    return Vue.http.patch(
      `${getters.endpoint.cartype}${id}/`,
      {
        ...changedFields
      },
      {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      }
    )
  },

  loadFieldsControlDict({ commit, getters }) {
    return Vue.http
      .get(getters.endpoint.fieldsControl, {
        params: {
          workspace: getters.workspace,
          version: getters.version
        }
      })
      .then((response) => {
        commit('setFieldsControlDict', response.body)
      })
  },

  updateAdditionalData({ getters }, { objectId, objectType, additionalData }) {
    let url = null

    switch (objectType) {
      case 'adm_territory':
        url = getters.endpoint.admterritory
        break
      case 'dedicated_territory':
        url = getters.endpoint.separateterritory
        break
      case 'zone':
        url = getters.endpoint.zones
        break
    }

    if (!url) {
      return
    }

    return Vue.http.patch(
      `${url}${objectId}/`,
      {
        additional_data: additionalData
      },
      {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          [getters.objectsPeriod.scaleType.id]: getters.objectsPeriod.selectedIntervals.join(',')
        }
      }
    )
  },

  layerLoadDefaultLayers({ commit, getters, dispatch }) {
    //Список сущностей через ","
    const layerLoadEntities = getters.availableLayerDataSources
      .filter((dataSource) => {
        return !SPECIAL_LAYERLOAD_ENTITIES.includes(dataSource)
      })
      .map((dataSource) => {
        return LAYERLOAD_ENTITY_BY_DATASOURCE[dataSource] || dataSource
      })
      .join(',')

    return dispatch('layerLoadRequest', {
      entity: layerLoadEntities,
      param: getters.getLayerLoadRequestParam({ entity: layerLoadEntities })
    }).then((result) => {
      //Обработка стандартных слоев
      Object.keys(result).forEach((layerLoadEntity) => {
        dispatch('updateDefaultLayerObjects', {
          layerId: LAYER_ID_BY_LAYERLOAD_ENTITY[layerLoadEntity] || layerLoadEntity, //Для некоторых слоев название в layerLoad и в настройка отличается
          layerObjectsFromServer: result[layerLoadEntity],
          clear: true //Здесь будем очищать объекты
        })
      })
    })
  },

  layerLoadZoneGroup({ commit, getters, dispatch }) {
    commit('setLayerSettingsField', {
      layerId: 'zonegroup',
      fieldName: 'loading',
      fieldValue: true
    })

    return dispatch('layerLoadRequest', {
      entity: 'zonegroup',
      param: getters.zoneGroupLayerLoadParam
    }).then((result) => {
      commit('setLayerSettingsField', {
        layerId: 'zonegroup',
        fieldName: 'loading',
        fieldValue: false
      })
      //Очистка слоев-зон
      dispatch('clearZoneLayerSettings')
      //Установка структуры зон
      dispatch('setInitialZonegroupStructure', {
        layerId: 'zonegroup',
        zonegroupServerData: result.zonegroup,
        zonegroupInfoServerData: result.zonegroup_info
      })
    })
  },

  layerLoadInfrastructure({ commit, getters, dispatch }) {
    commit('setLayerSettingsField', {
      layerId: 'infrastructure',
      fieldName: 'loading',
      fieldValue: true
    })

    return dispatch('layerLoadRequest', {
      entity: 'infrastructure',
      param: getters.infrastructureLayerLoadParam
    }).then((result) => {
      commit('setLayerSettingsField', {
        layerId: 'infrastructure',
        fieldName: 'loading',
        fieldValue: false
      })
      dispatch('prepareInfrastructureLayerSettings', {
        layerId: 'infrastructure',
        infrastructureLayerData: result.infrastructure
      })
      return result
    })
  },

  layerLoadFlow({ commit, getters, dispatch }) {
    const flowLayerSettings = getters.objectLayerSettings.flow
    if (!flowLayerSettings || !getters.flowLayerLoadParam) {
      return
    }

    commit('setLayerSettingsField', {
      layerId: 'flow',
      fieldName: 'loading',
      fieldValue: true
    })

    return dispatch('loadLayerObjects', {
      layerId: 'flow'
    }).then(() => {
      commit('setLayerSettingsField', {
        layerId: 'flow',
        fieldName: 'loading',
        fieldValue: false
      })
    })
  },

  layerLoadSource({ commit, getters, dispatch }) {
    const sourceLayerSettings = getters.objectLayerSettings.source
    if (!sourceLayerSettings || !getters.sourceLayerLoadParam) {
      return
    }

    commit('setLayerSettingsField', {
      layerId: 'source',
      fieldName: 'loading',
      fieldValue: true
    })

    return dispatch('loadLayerObjects', {
      layerId: 'source'
    }).then(() => {
      commit('setLayerSettingsField', {
        layerId: 'source',
        fieldName: 'loading',
        fieldValue: false
      })
    })
  },

  layerLoadInfoLayers({ commit, getters, dispatch }) {
    const infoLayerIds = ['info', 'streaminfo']

    infoLayerIds.forEach((layerId) => {
      commit('setLayerSettingsField', {
        layerId,
        fieldName: 'loading',
        fieldValue: true
      })
    })

    return dispatch('layerLoadRequest', {
      entity: 'infolayers',
      param: getters.getLayerLoadRequestParam({ entity: 'infolayers' })
    }).then((result) => {
      infoLayerIds.forEach((layerId) => {
        commit('setLayerSettingsField', {
          layerId,
          fieldName: 'loading',
          fieldValue: false
        })
      })
      dispatch('prepareInfoLayerSettings', {
        infoLayers: result.infolayers
      })
    })
  },

  layerLoadDefault({ commit, getters, dispatch }, { entity }) {
    commit('setLayerSettingsField', {
      layerId: LAYER_ID_BY_LAYERLOAD_ENTITY[entity] || entity,
      fieldName: 'loading',
      fieldValue: true
    })
    return dispatch('layerLoadRequest', {
      entity,
      param: getters.getLayerLoadRequestParam({ entity })
    }).then((result) => {
      commit('setLayerSettingsField', {
        layerId: LAYER_ID_BY_LAYERLOAD_ENTITY[entity] || entity,
        fieldName: 'loading',
        fieldValue: false
      })
      //Обработка стандартных слоев
      dispatch('updateDefaultLayerObjects', {
        layerId: LAYER_ID_BY_LAYERLOAD_ENTITY[entity] || entity, //Для некоторых слоев название в layerLoad и в настройка отличается
        layerObjectsFromServer: result[entity],
        clear: true //Здесь будем очищать объекты
      })
    })
  },

  layerLoadRequest({ commit, dispatch, getters }, { entity, param }) {
    if (!param) {
      return
    }

    commit('setObjectLoadingData', 1)
    const requestKey = `${entity.replace(/,/g, '')}LayerLoad`

    return Vue.http
      .get(getters.endpoint.allLayers, {
        params: {
          ...(NO_FILTER_ENTITIES.includes(entity) ? {} : getters.objectFilterRequestParams),
          ...param
        },
        before(request) {
          dispatch('abortMapRequest', {
            request,
            key: requestKey
          })
        }
      })
      .then((response) => {
        requests.requestKey = null
        return response.body
      })
      .catch((error) => {
        dispatch('handleMapErros', error)
        if (error.status !== 0) {
          throw error
        }

        throw {
          aborted: true
        }
      })
      .finally(() => {
        commit('setObjectLoadingData', 0)
      })
  },

  loadMapDataNew({ commit, dispatch, getters }, { layerServerId = null, dataSource, ...params }) {
    let requestKey = dataSource
    if (layerServerId) {
      requestKey += `-${layerServerId}`
    }

    commit('setObjectLoadingData', 1)
    return Vue.http
      .get(getters.endpoint.map[dataSource], {
        params: {
          workspace: getters.workspace,
          version: getters.version,
          ...params
        },
        before(request) {
          dispatch('abortMapRequest', { request, key: requestKey })
        }
      })
      .then((response) => {
        requests[requestKey] = null

        let layerMapData = response.body
        //Костыль для маршрутов инфослоя. И почему структура отличается?
        if (dataSource === 'streaminfoRoute') {
          layerMapData = layerMapData.result || null
        }

        //При обновлении данных инфослоя
        if (layerServerId) {
          layerMapData = {
            ...getters.objectMapData[dataSource],
            [layerServerId]: layerMapData
          }
        }

        const updatedMapData = {
          [dataSource]: layerMapData
        }
        commit('updateMapData', updatedMapData)
        commit('setObjectMapRequestTime', updatedMapData)

        return response.body
      })
      .catch((error) => {
        dispatch('handleMapErros', error)
      })
      .finally(() => {
        commit('setObjectLoadingData', 0)
      })
  },

  abortLoadMapDataRequest({}, { dataSource, layerServerId = null }) {
    let requestKey = dataSource
    if (layerServerId) {
      requestKey += `-${layerServerId}`
    }

    if (requests[requestKey]) {
      requests[requestKey].abort()
      requests[requestKey] = null
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/objects/actions.js